<div class="form-group">
  <div class="row noMarg">
    <label>Características</label>
  </div>
  <div class="row noMarg">
    <div class="col-12 col-md-6 mb-2">
      <input type="text" class="form-control" placeholder="Tipo" [(ngModel)]="type">
    </div>
    <div class="col-12 col-md-6">
      <input type="text" class="form-control" placeholder="Características" [(ngModel)]="value">
    </div>
  </div>
  <div class="row noMarg">
    <button class="btn harvest-gold base mt-3 mx-auto" (click)="add()" [disabled]="value == '' || type == ''">Adicionar Característica</button>
  </div>
  <div class="row noMarg d-flex flex-column pt-5">
    <ng-container *ngFor="let item of values; let i = index;">
      <div class="mb-2">
        <div class="row d-flex justify-content-center">
          <div class="col-10 p-0">
            <table class="table table-bordered table-striped table-dark text-white">
              <tr>
                <td class="text-justify" style="vertical-align: middle;">{{item}}</td>
                <td class="w-1 backgroundColor harvest-gold base" style="vertical-align: middle;" (click)="delete(item)"><fa-icon [icon]="faTrash" class="fal fa-trash textColor shark base"></fa-icon></td>
                <td class="w-1" style="vertical-align: middle;" (click)="swap(i,i-1)" *ngIf="1 < values.length && i > 0"><fa-icon [icon]="faChevronUp" class="fad fa-chevron-up"></fa-icon></td>
                <td class="w-1" style="vertical-align: middle;" (click)="swap(i,i+1)" *ngIf="1 < values.length && i < values.length-1"><fa-icon [icon]="faChevronDown" class="fad fa-chevron-down"></fa-icon></td>
              </tr>
            </table>
            <!--<div>
              <a>{{item}}</a>&nbsp;
              <a (click)="delete(item)" class="pointer"><i class="fad fa-times textColor red base"></i></a>
            </div>-->
          </div>
          <!--<div class="col-2">
            <!--<button class="btn harvest-gold base" (click)="swap(i,i-1)" *ngIf="1 < values.length && i > 0"><i class="fad fa-chevron-up"></i></button>
            <button class="btn harvest-gold base" (click)="swap(i,i+1)" *ngIf="1 < values.length && i < values.length-1"><i class="fad fa-chevron-down"></i></button>
            <div class="row" *ngIf="1 < values.length && i > 0">
              <div class="col">
                <button class="btn harvest-gold base" (click)="swap(i,i-1)"><i class="fad fa-chevron-up"></i></button>
              </div>
            </div>
            <div class="row" *ngIf="1 < values.length && i < values.length-1">
              <div class="col">
                <button class="btn harvest-gold base" (click)="swap(i,i+1)"><i class="fad fa-chevron-down"></i></button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </ng-container>
  </div>
</div>